import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Group } from '@iv/model/group';

@Injectable({providedIn: 'root'})
export class FuturesMonitorService {

  constructor(
    private http: HttpClient) { }

  public getAll(): Observable<HttpResponse<Group[]>> {
    return this.http.get<Group[]>('/futures-monitor/list', {observe: 'response'});
  }

  public getDefaultGroups(): Observable<HttpResponse<Group[]>> {
    return this.http.get<Group[]>('/futures-monitor/listDefault', {observe: 'response'});
  }

  getGroupData(
    mode,
    groupId: number,
    columns?: any[],
    screenerType?: string,
    termType?: string,
    tradeDatePeriod?: number,
    period?: number,
    percent?: number,
    sendUserMetrics?: boolean
  ): Observable<HttpResponse<any>> {

    const defaultColumns = ['symbol', 'companyname', 'exchange', 'quotetime', 'underlyingid'];
    const mergedColumns = [...columns, ...defaultColumns];

    const params = {
      mode: mode,
      groupId: groupId,
      columns: mergedColumns.filter((column: string, i: number) => mergedColumns.indexOf(column) === i)
    };

    if (screenerType) {
      params['screenerType'] = screenerType;
    }

    if (termType) {
      params['termType'] = termType;
    }

    if (tradeDatePeriod) {
      params['tradeDatePeriod'] = tradeDatePeriod;
    }

    if (period) {
      params['period'] = period;
    }

    if (percent) {
      params['percent'] = percent;
    }

    if (sendUserMetrics) {
      params['sendUserMetrics'] = sendUserMetrics;
    }

    return this.http
      .get('/futures-monitor/instruments', {
        observe: 'response', params: this.getHttpParams(params)
      });
  }

  addInstruments(groupId: number, underlyingIds: number[]): Observable<any> {
    return this.postToService('addInstrument', {groupId: groupId, stockId: underlyingIds});
  }

  deleteInstrument(groupId: number, underlyingIds: number[]): Observable<any> {
    return this.postToService('deleteInstrument', {groupId, underlyingIds});
  }

  createGroup(groupName: string): Observable<any> {
    return this.postToService('create', {groupName: groupName});
  }

  deleteGroup(groupId: number): Observable<any> {
    return this.postToService('delete', {groupId: groupId});
  }

  renameGroup(groupId: number, groupName: string): Observable<any> {
    return this.postToService('rename', {groupId: groupId, groupName: groupName});
  }

  uploadDataBlob(
    groupId: number,
    mode,
    stockIds: number[],
    columns?: string[],
    name?: string,
    screenerType?: string,
    termType?: string,
    tradeDatePeriod?: number,
    period?: number,
    percent?: number
  ) {
    let params = '';
    params += '&groupId=' + String(groupId);
    params += '&mode=' + String(mode);
    const stocks = JSON.stringify(stockIds);
    columns.forEach(item => {
      params += '&columns=' + String(item);
    });
    if (name) {
      params += '&fileName=' + name.split(' ').join('_');
    }
    if (screenerType) {
      params += '&screenerType=' + String(screenerType);
      if (termType) params += '&termType=' + String(termType);
      if (tradeDatePeriod) params += '&tradeDatePeriod=' + String(tradeDatePeriod);
      if (period) params += '&period=' + String(period);
      if (percent) params += '&percent=' + String(percent);
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post(`/futures-monitor/instruments/csv?${params}`, stocks, {
      headers: headers,
      responseType: 'text'
    });
  }

  getHttpParams(paramsObj: Object) {
    let httpParams = new HttpParams();
    for (const key in paramsObj) {
      httpParams = httpParams.set(key, paramsObj[key]);
    }
    return httpParams;
  }

  getColumns(): Observable<any> {
    return this.http.get('/iv-live/assets/futures_monitor_columns.json?version=5');
  }

  getGlobalDate(): Observable<{"today": string, "tomorrow": string}> {
    return this.http.get<{"today": string, "tomorrow": string}>('/user-settings/global');
  }
  private postToService(method: string, paramsObj: Object) {
    const body = this.getHttpParams(paramsObj);
    return this.http.post(`/futures-monitor/${method}`, body);
  }
}
